// ** MUI Imports
import { createGenericContext } from "../../utils/createGenericContext";
import { useAuth } from "../../auth";
import { useEffect, useState } from "react";
import FormsService from "../../services/FormsService";

export interface IAppContext {
  dashboardText: string;
  appName: [string, string];
}

const [useAppContext, AppContextProvider] = createGenericContext<IAppContext>();

const AppProvider = (props: any) => {
  const [appName, setAppName] = useState<[string, string]>([
    "Mental Health Online",
    "MHO",
  ]);
  const [dashboardText, setDashboardText] = useState<string>("");

  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn) {
      FormsService.getInfo().then((res: any) => {
        setAppName([res.data.service, res.data.short]);
        setDashboardText(res.data.dashboardText);
      });
    } else {
      setAppName(["Mental Health Online", "MHO"]);
    }
  }, [isLoggedIn]);

  let contextValue = {
    dashboardText,
    appName,
  };

  return (
    <AppContextProvider value={contextValue}>
      {props.children}
    </AppContextProvider>
  );
};

export { AppProvider, useAppContext };
